export default __webpack_public_path__ + "static/media/FIGHT OR DIE 4.3f14fb17.png";